import { CallState, LoadingState } from "@app/root-store/api-result.state";
import { EntityInfo, EntityInfoType } from "../model/entityinfo";

export interface EntityInfoState {
    entityinfos: { result: { [id: number]: EntityInfo }; callState: CallState<EntityInfo> };
    entityinfoTypes: { result: { [id: number]: EntityInfoType }; callState: CallState<EntityInfoType> };
}

export const initialEntityInfoState: EntityInfoState = {
    entityinfos: {
        result: {},
        callState: LoadingState.init,
    },
    entityinfoTypes: {
        result: {},
        callState: LoadingState.init,
    },
};
